import { render, staticRenderFns } from "./LoggedInHeader.vue?vue&type=template&id=90840c76&scoped=true"
import script from "./LoggedInHeader.vue?vue&type=script&lang=js"
export * from "./LoggedInHeader.vue?vue&type=script&lang=js"
import style0 from "./LoggedInHeader.vue?vue&type=style&index=0&id=90840c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90840c76",
  null
  
)

export default component.exports